<template>
  <div class="memberDetail pages">
    <h3 class="pageTitle">{{$t('memberlist.accout_detail')}} <span class="back"
            @click="backlist"><el-link type="primary">{{$t('memberlist.back_list')}}</el-link></span></h3>
    <el-container v-loading="loading"
                  :element-loading-text="$t('memberlist.loading')">
      <el-header style="height:20px;"></el-header>
      <div class="infoTitle">
        <div class="info">
          <span>{{ userAccount}} UC Information</span>
          <span class="editAccout"
                @click="modify"
                v-show="!edit"><el-link type="primary">{{$t('memberlist.modify')}}</el-link></span>
        </div>
        <!-- <div class="forbiden">
     
                <el-switch
                    @change="changeStatus(userInfo.id)"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    v-model="ac_state">
                </el-switch>
                 <span style="margin-left: 20px">{{userInfo.state === 2?$t('memberlist.activate_ac'):$t('memberlist.suspend_ac')}}</span>
            </div> -->
      </div>
      <el-form :model="userInfo"
               :rules="rule1"
               ref="userInfo"
               :label-position="lp"
               :label-width="lw"
               :class="edit? 'detailForm': 'onlyread  detailForm'">
        <el-form-item :label="$t('memberlist.name')"
                      prop="username"
                      class="formItem">
          <el-input v-model="userInfo.username"
                    :disabled="!edit"
                    v-show="edit"></el-input>
          <span v-show="!edit">{{ userInfo.username }}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.pass_card')"
                      prop="account"
                      class="formItem">
          <!-- <el-input v-model="userInfo.account" :disabled="!edit" v-show="edit"></el-input> -->
          <span>{{ userInfo.account }}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.department')"
                      prop="depart_id_beisen"
                      class="formItem">
          <wlTreeSelect :defaultExpandAll='false'
                        width="320"
                        id="depart_id_beisen_selecter"
                        :data="departments"
                        v-model="new_select"
                        @change="select_change"
                        v-if="edit"></wlTreeSelect>

          <!-- <tSelect></tSelect> -->
          <span v-show="!edit"
                :title="userInfo.depart_name_path">{{ userInfo.depart_name_path }}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.position')"
                      prop="job_id"
                      class="formItem">

          <el-select v-model="userInfo.job_id"
                     filterable
                     :placeholder="$t('memberlist.p_select')"
                     v-show="edit"
                     :disabled="!edit">
            <el-option v-for="item in jobs"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
          <span v-show="!edit">{{ userInfo.job_name }}</span>

        </el-form-item>

        <el-form-item :label="$t('memberlist.join_time')"
                      prop="entry_date"
                      class="formItem">
          <el-date-picker :disabled="!edit"
                          v-show="edit"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :placeholder="$t('memberlist.p_select')"
                          v-model="userInfo.entry_date"
                          style="width: 100%;"></el-date-picker>
          <span v-show="!edit">{{ userInfo.entry_date }}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.gender')"
                      prop="gender"
                      class="formItem">
          <el-radio-group v-model="userInfo.gender"
                          v-show="edit">
            <el-radio :label="0"
                      :disabled="!edit">{{$t('memberlist.male')}}</el-radio>
            <el-radio :label="1"
                      :disabled="!edit">{{$t('memberlist.female')}}</el-radio>
            <el-radio :label="2"
                      :disabled="!edit">{{$t('memberlist.confidential')}}</el-radio>
          </el-radio-group>
          <span v-show="!edit">{{ gender[userInfo.gender]}}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.status')"
                      prop="state"
                      class="formItem">
          <el-radio-group v-model="userInfo.state"
                          v-show="edit">
            <el-radio :label="1">{{$t('memberlist.active')}}</el-radio>
            <el-radio :label="2">{{$t('memberlist.suspended')}}</el-radio>
          </el-radio-group>

          <span v-show="!edit">{{ showstate }}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.gg_key')"
                      prop="gg_key"
                      class="formItem">
          <div v-show="!edit && userInfo.gg_key">
            <span v-show="showkey">{{  userInfo.gg_key && hideCode(userInfo.gg_key, 3, 12) }}</span>
            <span v-show="!showkey">{{  userInfo.gg_key }}</span>
            <span @click="showkey = !showkey"
                  v-show="showkey"
                  class="view el-icon-view"></span>
            <span @click="showkey = !showkey"
                  class="eyes"
                  v-show="!showkey">
            </span>
          </div>
          <div v-show="edit"
               class="viewContent">
            <el-input v-model="userInfo.gg_key"
                      :disabled="!edit"></el-input>
            <el-button type="warning" plain
                       @click="resetKey">{{$t('memberlist.reset')}}</el-button>
          </div>
        </el-form-item>
        <!-- 直接上级 | supervisor_account -->
        <el-form-item :label="$t('memberlist.supervisor_account')"
                      prop="entry_date"
                      class="formItem">
          <div v-show="edit">
            <el-select v-model="userInfo.supervisor_account"
                       style="width: 100%;"
                       :placeholder="$t('memberlist.p_select')"
                       filterable
                       remote
                       clearable
                       :remote-method="remoteMethod"
                       :loading="remoteLoading"
                       no-match-text="没有匹配到数据">
              <el-option v-for="item in options"
                         :key="item.account"
                         :label="item.account"
                         :value="item.account">
              </el-option>
            </el-select>
          </div>
          <span v-show="!edit">{{ userInfo.supervisor_account || '--' }}</span>
        </el-form-item>
        <el-form-item :label="$t('memberlist.email')"
                      prop="email"
                      class="formItem">
          <el-input v-model="userInfo.email"
                    :disabled="!edit"
                    v-show="edit"></el-input>
          <span v-show="!edit">{{ userInfo.email }}</span>
        </el-form-item>
        <el-form-item :label="$t('memberlist.creat_time')"
                      prop="ctime"
                      v-show="!edit"
                      class="formItem">
          <span>{{ userInfo.ctime || ' '}}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.pws_time')"
                      prop="mtime"
                      v-show="!edit"
                      class="formItem">
          <span>{{ userInfo.mtime || ' '}}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.last_mod')"
                      prop="utime"
                      v-show="!edit"
                      class="formItem">
          <span>{{ userInfo.utime || ' '}}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.mod_person')"
                      prop="op_user"
                      v-show="!edit"
                      class="formItem">
          <span>{{ userInfo.op_user || ' '}}</span>
        </el-form-item>
      </el-form>

    </el-container>
    <div class="moreOp">
      <section v-show="!edit">
        <el-button type="primary"
                   @click='handClick("clearNumber")'
                   round>{{$t('memberlist.clear_err')}}</el-button>
        <el-button type="danger"
                   @click='resetpsw()'
                   round>{{$t('memberlist.reset_psw')}}</el-button>
      </section>

      <section v-show="edit">
        <el-button class="my_btn"
                   round
                   @click="cancel">{{$t('memberlist.cancel')}}</el-button>
        <el-button class="my_btn"
                   type="primary"
                   :loading="saving"
                   round
                   @click="save">{{$t('memberlist.save')}}</el-button>
      </section>

    </div>
    <el-dialog :title="$t('memberlist.reset_pwd')"
               :visible.sync="pswVisible"
               width="30%"
               :before-close="passClose"
               center>
      <el-form :model="pswInfo"
               ref="pswInfo"
               :rules="passRules"
               class="clearfix psw">

        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="7">UC Passport</el-col>
            <el-col :span="14">
              {{userAccount}}
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="password">
          <el-row :gutter="20">
            <el-col :span="7">{{$t('memberlist.psw')}}</el-col>
            <el-col :span="14">
              <el-input v-model="pswInfo.password"></el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="checkPass">
          <el-row :gutter="20">
            <el-col :span="7">{{$t('memberlist.c_psw')}}</el-col>
            <el-col :span="14">
              <el-input v-model="pswInfo.checkPass"></el-input>
            </el-col>
          </el-row>

        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="resetCancel('pswInfo')">{{$t('memberlist.cancel')}}</el-button>
        <el-button type="primary"
                   @click="resetPwdSubmit()">{{$t('memberlist.confirm')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  memberDetail,
  clearNumber,
  sendEmail,
  editInfo,
  getKey,
  sendemailaccount,
  searchByAccount
} from "@/api/api.js";
import validators from "@/utils/validator.js";
import { hideCode } from "@/utils/filters.js";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "memberDetail",

  mixins: [validators],
  data() {
    return {
      userInfo: {},
      edit: false,
      switchStatus: true,
      gender: [
        this.$t("memberlist.male"),
        this.$t("memberlist.female"),
        this.$t("memberlist.confidential")
      ],
      lp: "left",
      lw: "150px",
      pswVisible: false,
      pswInfo: {
        password: "",
        account: ""
      },
      showkey: true,
      showphone: true,
      showIdNum: false,
      ac_state: false,
      statearr: [
        "",
        this.$t("memberlist.active"),
        this.$t("memberlist.suspended"),
        this.$t("memberlist.locked")
      ],
      userAccount: "",
      userid: "",
      loading: true,
      saving: false,
      remoteLoading: false,
      keyWord: "",
      options: []
    };
  },
  activated() {
    this.getData();
  },
  computed: {
    showstate: {
      get: function () {
        let arr = [
          "",
          this.$t("memberlist.active"),
          this.$t("memberlist.suspended"),
          this.$t("memberlist.locked")
        ];
        return arr[this.userInfo.state];
      },
      set: function () {}
    },
    job_state: {
      get: function () {
        return ["", this.$t("memberlist.bs_1"), this.$t("memberlist.bs_2")];
      },
      set: function () {}
    },
    beisen_status: {
      get: function () {
        return [
          "",
          this.$t("memberlist.bs_3"),
          this.$t("memberlist.bs_4"),
          this.$t("memberlist.bs_5"),
          this.$t("memberlist.bs_6"),
          this.$t("memberlist.bs_7"),
          this.$t("memberlist.bs_8"),
          "",
          this.$t("memberlist.bs_9"),
          "",
          "",
          "",
          this.$t("memberlist.bs_10")
        ];
      },
      set: function () {}
    },
    is_deleted: {
      get: function () {
        return [this.$t("memberlist.bs_11"), this.$t("memberlist.bs_12")];
      },
      set: function () {}
    },
    ...mapGetters(["lang"]),
    new_select: {
      get: function () {
        return [this.userInfo.depart_id_beisen + ""];
      },
      set: function (newValue) {
        this.userInfo.depart_id_beisen = newValue[0] && newValue[0].id;
      }
    }
  },
  methods: {
    remoteMethod(searchKey) {
      //输入值发生变化时的回调函数
      if (searchKey !== "") {
        this.remoteLoading = true;
        this.keyWord = searchKey;
        this.getRemote();
      } else {
        this.options = [];
      }
    },
    getRemote: _.debounce(function () {
      //防抖，这里设置300毫秒请求一次后台
      console.log(this.keyWord);
      this.searchByAccount({
        keyword: this.keyWord
      });
    }, 300),
    async searchByAccount(params) {
      let res = await searchByAccount(params);
      this.remoteLoading = false;
      this.options = res?.list.map((item) => ({
        account: item.account,
        username: `${item.username}(${item.account})`
      }));
    },
    hideit() {
      let host = window.location.hostname;
      return /lalamove/.test(host);
    },
    select_change(val) {
      this.$refs.userInfo.validateField("depart_id_beisen");
      this.$nextTick(() => {
        document.querySelector(".wl-select-tag").childNodes[0].textContent =
          (val[0] && val[0].name_path) || "";
      });
    },
    resetKey() {
      getKey().then((res) => {
        this.userInfo.gg_key = res && res.gg_key;
      });
    },
    hideCode(str, s, e) {
      return hideCode(str, s, e);
    },
    backlist() {
      if (this.edit) {
        this.$message({
          message: this.$t("memberlist.c_edite"),
          type: "warning"
        });
        return false;
      } else {
        this.$router.push({ path: "/homePage/memberList" });
      }
    },
    cancel() {
      this.edit = false;

      this.getData();
    },
    save() {
      let params = this.userInfo;

      let userInfo_depart_id_beisen_v0 = 0;
      let dptSelectObj = document.getElementById('depart_id_beisen_selecter').querySelector(".wl-select-tag");
      if (!dptSelectObj) {
        console.log('no depart_id_beisen_selecter')
        userInfo_depart_id_beisen_v0 = this.userInfo.depart_id_beisen;
        this.userInfo.depart_id_beisen = 0;
        this.userInfo.depart_name = '';
        this.userInfo.depart_name_path = '';
      } else {
        //console.log('----wewe----0-', document.getElementById('depart_id_beisen_selecter').querySelector(".wl-select-tag"))
        console.log('----dptSelectObj---textContent--', dptSelectObj.childNodes[0].textContent)
      }

      this.$refs["userInfo"].validate((valid) => {
        this.saving = true;
        (valid &&
          editInfo(params)
            .then(() => {
              this.edit = false;
              this.saving = false;
              this.$message({
                message: this.$t("memberlist.msg_save"),
                type: "success"
              });
              this.getData();
            })
            .catch(() => {
              this.saving = false;
            })) ||
          (this.saving = false);
      });
    },
    resetPwdSubmit(){
      this.resetSure();
      setTimeout("window.location.reload()",3200);
    },
    async getData() {
      this.userid = this.$route.params.id;
      this.userAccount = this.$route.params.user;

      const data = await memberDetail(this.userid);
      this.loading = false;
      this.$refs.userInfo.resetFields();

      this.userInfo = data;
      !this.userInfo.job_id && (this.userInfo.job_id = "");
      this.ac_state = this.userInfo.state === 1 ? true : false;
      this.ucWatermark();
    },
    handClick(opName) {
      let params = this.userid;
      switch (opName) {
        case "clearNumber":
          clearNumber({ account: this.userAccount }).then(() => {
            this.$message({
              message: this.$t("memberlist.clear_err_ss"),
              type: "success"
            });
          });
          break;
        case "sendEmail":
          sendEmail(params).then(() => {
            this.$message({
              message: this.$t("memberlist.msg_send_email"),
              type: "success"
            });
          });
          break;
        default:
          sendemailaccount(params).then(() => {
            this.$message({
              message: this.$t("memberlist.msg_send_person"),
              type: "success"
            });
          });
      }
    },
    resetpsw() {
      (this.pswInfo = {
        password: "",
        account: "",
        checkPass: ""
      }),
        (this.random = "");
      this.pswVisible = true;
    },
    modify() {
      this.edit = true;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.memberDetail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .back {
    margin-left: 20px;
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
  }
  .detailForm {
    width: 100%;
    padding-left: 5%;
    box-sizing: border-box;
    // justify-content: space-between;
  }
  .formItem {
    margin-right: 5%;
  }
  .infoTitle {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    padding-right: 10%;
    padding-left: 40px;
    font-weight: 600;
    color: #000;
    .editAccout {
      margin-left: 20px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .el-form-item {
    min-width: 300px;
    width: 40%;
    margin-bottom: 10px;
    float: left;
    .viewContent {
      display: flex;
      justify-content: space-between;
      .el-button {
        margin-left: 20px;
      }
    }
    .view {
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .psw {
    .el-form-item {
      width: 100%;
    }
  }
  .moreOp {
    display: flex;
    justify-content: space-around;
    // width: 60%;
    margin: 40px 0 0 0;
  }
  .dialog-footer {
    display: inline-block;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    margin-left: -12px;
  }
  .onlyread {
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      content: "";
    }
  }
  .psw {
    .el-form-item__error {
      left: 22%;
    }
  }
}
.my_btn {
  min-width: 110px;
}
.randomPsw {
  height: 28px;
  line-height: 28px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  color: #c0c4cc;
  border-radius: 5px;
  margin-top: 5px;
  padding-left: 10px;
}
.eyes {
  width: 14px;
  height: 14px;
  background: url(../assets/eye.png) no-repeat center;
  background-size: 14px 14px;
  display: inline-block;
  margin-left: 15px;
  cursor: pointer;
}
</style>
